import { render, staticRenderFns } from "./SchoolVerificationInfo.vue?vue&type=template&id=244132fd&scoped=true"
import script from "./SchoolVerificationInfo.vue?vue&type=script&lang=ts"
export * from "./SchoolVerificationInfo.vue?vue&type=script&lang=ts"
import style0 from "./SchoolVerificationInfo.vue?vue&type=style&index=0&id=244132fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244132fd",
  null
  
)

export default component.exports